var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProGroupcalIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    rx: 7,
    fill: "#ED3C47"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4 9L3 3.5L5.44444 6L7 3L8.55556 6L11 3.5L10 9H4ZM10 10.5C10 10.8 9.93333 11 9.66667 11H4.33333C4.06667 11 4 10.8 4 10.5V10H10V10.5Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProGroupcalIcon);
export default __webpack_public_path__ + "static/media/pro-groupcal-icon.4dce778901e3130b9aa11f925ea99232.svg";
export { ForwardRef as ReactComponent };